import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    TDeviceRef,
    DeviceReference,
} from "../../types/devices/ttr/getDeviceReferenceTypes"

type TGetDeviceReferenceMapper = {
    map: (response: unknown) => TDeviceRef
}

export const getDeviceReferenceMapper: TGetDeviceReferenceMapper = {
    /** Maps the response returned from the GET device reference endpoint to a ts-io derived type representing the result */
    map: (response: unknown) =>
        tsIoValidate(DeviceReference, response, "getDeviceReferenceMapper"),
}
